import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconCancelStyle0 = cosmosIconCss;

const CosmosIconCancel$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconCancel extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '96a4b1e3e97e817ba69bc737cf4d69ed12d4c533', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'e179962d40f9c9e2a2fa7133c72fa28e9e8606de', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'c8fb5df3b82e078deea00338ade78a1ee6437ebf', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 2a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9Zm0 1.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15Zm3.36 3.79.35.35a.51.51 0 0 1 0 .71L12.06 11l2.65 2.65a.51.51 0 0 1 0 .71l-.35.35a.5.5 0 0 1-.71 0L11 12.06l-2.65 2.65a.5.5 0 0 1-.71 0l-.35-.35a.5.5 0 0 1 0-.71L9.94 11 7.29 8.35a.5.5 0 0 1 0-.71l.35-.35a.5.5 0 0 1 .71 0L11 9.94l2.65-2.65a.5.5 0 0 1 .71 0Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconCancelStyle0; }
}, [1, "cosmos-icon-cancel", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-cancel"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-cancel":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconCancel$1);
            }
            break;
    } });
}

const CosmosIconCancel = CosmosIconCancel$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconCancel, defineCustomElement };
